import { render, staticRenderFns } from "./NotesPfd.vue?vue&type=template&id=5fb01b9c&"
import script from "./NotesPfd.vue?vue&type=script&lang=js&"
export * from "./NotesPfd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports